import { Component, EventEmitter, Output } from '@angular/core';

// Excel upload modal for vehicle working hours.
@Component({
  selector: 'excel-upload-modal',
  templateUrl: './excel-upload-modal.component.html',
})
export class ExcelUploadModalComponent {
  @Output() browseRequested = new EventEmitter<void>();
  @Output() fileSelected = new EventEmitter<any>();
  @Output() saved = new EventEmitter<void>();

  onFileChange(event: any): void {
    this.fileSelected.emit(event);
  }
}
